import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { SPECIAL_AGENT_IDS } from '@/entities/agent';
import { getCurrentOrganizationId, usePermissions } from '@/entities/user';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { startChatSession, useChatStore } from '@/features/chats';
import { personaLabel } from '@/shared/lib/persona-label';

interface PersonaToTalkTo {
  personaId: string;
  personaTitle?: string;
  segmentName?: string;
}

export const useStartPersonaChat = () => {
  const { t } = useTranslation('analysis');
  const navigate = useNavigate();
  const workspaceId = useCurrentWorkspaceId();
  const { canOpenTool } = usePermissions();

  // No handler, so the menu leaves the entry out, rather than one that opens a chat whose agent 404s.
  if (!canOpenTool(SPECIAL_AGENT_IDS.AUDIENCE_FLOW)) return undefined;

  return async ({ personaId, personaTitle, segmentName }: PersonaToTalkTo) => {
    await useChatStore.getState().setAgentById(SPECIAL_AGENT_IDS.AUDIENCE_FLOW);

    const personaName = personaLabel({ personaTitle, segmentName });

    await startChatSession(useChatStore.getState().initializeChat, navigate, {
      agentId: SPECIAL_AGENT_IDS.AUDIENCE_FLOW,
      prompt: t('analysisResult.iqpersonaDetail.iWantToSpeakWith', { personaName }),
      inputs: { personaId },
      visibilityScope: {
        workspaceId,
        organizationId: getCurrentOrganizationId(),
      },
    });
  };
};
